module.exports = __webpack_public_path__ + "static/media/signatures.8dd17186.svg";